import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {  setsearchedInvoices } from "../actions/InvoiceActions";
import { updateState } from "../actions/CommonActions";
import { FormattedMessage, useIntl } from "react-intl";
import * as types from "../constants/ActionTypes";

export function CompanyCodeSelect({ companycodes, defaultCompanyCode,clearSelectedInvoices,primaryAccount }) {
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const dispatch = useDispatch();
  const intl = useIntl();
  const f = (id) => intl.formatMessage({ id: id });
  const handleCheckChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = event.currentTarget;

    if (clearSelectedInvoices) clearSelectedInvoices();
    if (setsearchedInvoices) setsearchedInvoices([]);

    setSelectedItems((prevItems) =>
      checked ? [...prevItems, id] : prevItems.filter((item) => item !== id)
    );
  };

  const allSelected = () =>  selectedItems.length === companycodes.length;
const COMPANY_CODE_TO_BUSINESS_UNIT = {
  US10: "Vision Care",
  US20: "Surgical",
  US30: "Pharma",
  CA60: "B+L",
};
  const createSelectItems = () => {
    return companycodes.map((item) => {
      const isChecked = selectedItems.includes(item);
      const itemColor = isChecked
        ? "checkbox checkbox-primary dropdown-item truncate multiSelectItemColor"
        : "checkbox checkbox-primary dropdown-item truncate";

      return (
        <li key={`li_${item}`}>
          <div className={itemColor}>
            <label>
              <input
                className="checkMargin"
                type="checkbox"
                id={item}
                onChange={handleCheckChange}
                checked={isChecked}
              />
             {COMPANY_CODE_TO_BUSINESS_UNIT[item] || item}
            </label>
          </div>
        </li>
      );
    });
  };

  useEffect(() => {
    setSelectedItems([defaultCompanyCode]);
    createSelectItems();
}, [defaultCompanyCode,primaryAccount]);

  useEffect(() => {
    updateState(dispatch, types.UPDATE_COMPANY_CODES,  [selectedItems]);
  
  }, [selectedItems]);
 
  return (
    <div className="btn-group btn-block soldto-select customSelect">
      <button
        className="form-control soldToBtnColor btn-block dropdown-toggle"
        id="soldToToggle"
        type="button"
        data-toggle="dropdown"
      >
        <span>{selectedItems.length} {f("invoice_filter_business_unit")}</span>
        <span className="select-arrow">
          <i className="fas fa-chevron-down"></i>
        </span>
      </button>
      <ul className="dropdown-menu multiSelectMenuHeight">
        <li>
          <div className="checkbox checkbox-primary dropdown-item truncate">
            <label htmlFor="lbl_ship_to_select_all">
              <input
                className="checkMargin"
                type="checkbox"
                id="lbl_ship_to_select_all"
                checked={allSelected()}
                onChange={() => {
                  if (allSelected()) {
                    setSelectedItems([]);
                  } else {
                    setSelectedItems(companycodes);
                  }
                }}
              />
              Select All
            </label>
          </div>
        </li>
        {createSelectItems()}
      </ul>
    </div>
  );
}
